export default defineNuxtRouteMiddleware(async (to, from) => {
  const localePath = useLocalePath();

  if (!Boolean(to.query?.query)) {
    return navigateTo(localePath('/support'))
  }
});
